import { render, staticRenderFns } from "./BrandSettings.vue?vue&type=template&id=53c5d259&"
import script from "./BrandSettings.vue?vue&type=script&lang=js&"
export * from "./BrandSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports